// Mobile 框架未支持配置化

export const MOBILE_PAGE_CONFIG = {
  showUnconfiguredPage: true,
  unconfiguredComponentName: 'MobileDaily',
  unconfiguredComponentProps: {
    intelligenceUrlTemplate: '/intelligence/topCharts/mobileGames/gamesDetails/{unifiedid}',
    opinionUrlMap: {
      gst: '/opinion/Overview/KeyOpinions'
    }
  }
};